@if (settings && settings.enabled) {
  <div class="shell-content">
    <router-outlet></router-outlet>
  </div>

  <div class="shell-footer">
    @if (settings?.footerText) {
      <div class="footer-text">
        {{ settings.footerText }}
      </div>
    }
    <div class="additional-info">
      @if (settings?.contactPhone) {
        <div class="column">
          <span class="label">Tel:</span>
          <span class="value">{{ settings.contactPhone }}</span>
        </div>
      }
      @if (settings?.contactEmailAddress) {
        <div class="column">
          <span class="label">Email:</span>
          <span class="value">{{ settings.contactEmailAddress }}</span>
        </div>
      }
      <div class="column">
        @if (settings?.websiteUrl) {
          <span class="value">
            <a class="value" [href]="settings.websiteUrl" target="_blank">Learn more...</a>
          </span>
        }
      </div>
    </div>

    <div class="food-checker-branding">
      @if (this.settings) {
        <img
          src="assets/theFoodChecker-logo-col{{ this.settings?.brandingImage }}-withoutStrap.svg"
          class="pivot-logo"
          routerLink="/" />
      }
    </div>
  </div>
}

@if (settings) {
  <pi-slide-menu #SlideMenu [settings]="settings" />
}

@if (showUnderConstruction | async) {
  <pi-under-construction [settings]="settings" />
}

@if (showDisclaimer | async) {
  <pi-disclaimer [settings]="settings" />
}
